import * as types from "constants/ActionTypes";

// Function for toggleButton in the navbar.
export const toggleButtonOnClick = () => (dispatch, getState) => {
  return dispatch({
    type: types.TOGGLE_BUTTON_CLICK,
    value: {
      clickToggleButton: !getState().clickToggleButton
    }
  });
};

export const collapseSidebar = () => (dispatch, getState) => {
  return dispatch({
    type: types.TOGGLE_BUTTON_CLICK,
    value: {
      clickToggleButton: false
    }
  });
};
